module.exports = __webpack_public_path__ + "static/media/icn-map-point.61cf0b50.svg";